export async function hasAppliedToVacancy(api, jobId) {
  for (let page = 1; ; page += 1) {
    const { data } = await api.get("/applications/mine", { params: { page, size: 100 } });
    if (!Array.isArray(data?.items) || !Number.isInteger(data.pages) || data.pages < 0) {
      throw new Error("Invalid application history response");
    }
    if (data.items.some((item) => item.job_id === jobId && item.is_deleted !== true)) return true;
    if (page >= data.pages) return false;
  }
}
